var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ld-link-symbol",class:{ 'hover-underline': _vm.underline }},[(_vm.href)?_c('a',{attrs:{"href":_vm.href,"target":{ '_blank': _vm.blank }}},[_vm._t("default")],2):_c('router-link',{attrs:{"to":_vm.link || _vm.jumpLink}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d319c19c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stories/linkSymbol/index.vue
// module id = null
// module chunks = 